export default __webpack_public_path__ + "static/media/Image_Icons.e6e3534e.svg";